import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';

const closeModalCallback = history => {
  history.push('/');
};

const AdvertiserRegistrationSuccessModal = ({ closeModal, history }) => (
  <div className="advertiser-reg-success">
    <div className="advertiser-reg-inner">
      <button
        type="button"
        className="popup-close"
        onClick={closeModal.bind(
          null,
          event,
          closeModalCallback.bind(null, history),
        )}>
        <i className="icon-cross-rounded" />
      </button>

      <div className="advertiser-reg-icon">
        <i className="icon-check-rounded" />
      </div>

      <div className="advertiser-reg-text">
        <h2>
          <FormattedMessage
            id="advertiser.register.success_modal.title"
            defaultMessage="Your application is accepted!"
          />
        </h2>
        <p>
          <FormattedMessage
            id="advertiser.register.success_modal.text"
            defaultMessage="Our specialists will contact you within 5 working days."
          />
        </p>
      </div>
    </div>
  </div>
);

export default withRouter(AdvertiserRegistrationSuccessModal);
